import React from "react";

/* Stylized logo: text with Christmas decorations (star atop letter A/X, snow caps,
   candy-stripe accents). If `imageUrl` supplied, uses it instead. */
export default function StylizedLogo({ text, imageUrl, lang, size = "lg", className = "" }) {
  if (imageUrl) {
    return <img src={imageUrl} alt={text} className={`${size === "lg" ? "h-20 md:h-28" : "h-10"} ${className}`} />;
  }
  const sizes = {
    lg: { fontSize: "clamp(2.5rem, 7vw, 5rem)", letterSpacing: "-0.02em" },
    md: { fontSize: "clamp(1.5rem, 3vw, 2rem)", letterSpacing: "-0.01em" },
    sm: { fontSize: "1.25rem", letterSpacing: "0" },
  };
  return (
    <div className={`inline-block relative ${className}`} style={sizes[size]}>
      <span className="font-fredoka font-bold text-[#0B1D3A] relative inline-block">
        {/* Hanging star above first letter */}
        <span
          aria-hidden
          className="absolute -top-3 left-0 text-[#FFD93D]"
          style={{
            fontSize: "0.6em",
            filter: "drop-shadow(0 0 6px #FFD93D)",
            animation: "float-light 3s ease-in-out infinite",
          }}
        >★</span>
        {/* Snow cap accent on tallest char (uses ::before via inline span) */}
        <span style={{ position: "relative", display: "inline-block" }}>
          {text}
        </span>
      </span>
      {/* Candy-stripe underline */}
      <span
        aria-hidden
        className="block mx-auto mt-1"
        style={{
          height: 6,
          width: "60%",
          borderRadius: 9999,
          background: "repeating-linear-gradient(45deg, #FF6B6B 0 10px, #FFFFFF 10px 20px)",
          boxShadow: "0 2px 0 rgba(0,0,0,0.06)",
        }}
      />
    </div>
  );
}
